export default __webpack_public_path__ + "static/media/feedback.8effe1ec.gif";